import type {
  PaywallNetworkHandler,
  PaymentRequirements,
  PaymentRequired,
  PaywallConfig,
} from "../types";
import { getTonPaywallHtml } from "./paywall";

// Re-export wallet utilities for server-side use
export {
  fetchTonWallets,
  getBundledWallets,
  filterWalletsByPlatform,
  generateWalletDeepLink,
  resetWalletsCache,
} from "./wallets";
export type { TonWalletInfo, TonWalletPlatform, TonWalletBridge } from "./wallets";

/**
 * TON paywall handler that supports TON-based networks (CAIP-2 format)
 */
export const tonPaywall: PaywallNetworkHandler = {
  /**
   * Check if this handler supports the given payment requirement
   *
   * @param requirement - The payment requirement to check
   * @returns True if this handler can process this requirement
   */
  supports(requirement: PaymentRequirements): boolean {
    return requirement.network.startsWith("ton:");
  },

  /**
   * Generate TON-specific paywall HTML
   *
   * @param requirement - The selected payment requirement
   * @param paymentRequired - Full payment required response
   * @param config - Paywall configuration
   * @returns HTML string for the paywall page
   */
  generateHtml(
    requirement: PaymentRequirements,
    paymentRequired: PaymentRequired,
    config: PaywallConfig,
  ): string {
    // USDT on TON uses 6 decimals
    const amount = requirement.amount
      ? parseFloat(requirement.amount) / 1000000
      : requirement.maxAmountRequired
        ? parseFloat(requirement.maxAmountRequired) / 1000000
        : 0;

    return getTonPaywallHtml({
      amount,
      paymentRequired,
      currentUrl: paymentRequired.resource?.url || config.currentUrl || "",
      testnet: config.testnet ?? true,
      appName: config.appName,
      appLogo: config.appLogo,
      theme: config.theme,
    });
  },
};
